export default __webpack_public_path__ + "static/file-46846c3bcfd2b1763a2fc6ce1274aa0f.png";